import { defineModule } from "direct-vuex"

import * as SingleModule from './SingleModule'

export const internal = {
    namespaced: true as const,
    modules: {
        single: SingleModule.module,
    }
}

export const module = defineModule(internal)

export default module
